import React from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import localeText from "../../../locale";

const ConfimeaConfirmationActions = ({
  onSendDocument,
  sendingDocument,
  documentCloudinaryId,
}) => {
  return (
    <>
      <div className="confimea-confirmation-info text-center text-sm">
        {localeText("documentsVerificationInfo")}
      </div>

      <div className="confimea-confirmation-actions">
        <Link to="/login" className="confimea-btn confimea-btn-outline">
          {localeText("skipAndGoToLogin")}
        </Link>
        <Button
          className="confimea-btn confimea-btn-primary"
          label={localeText("sendDocumentation")}
          onClick={onSendDocument}
          loading={sendingDocument}
          disabled={!documentCloudinaryId || sendingDocument}
        />
      </div>

      <p className="confimea-confirmation-privacy">{localeText("privacyNote")}</p>
    </>
  );
};

export default ConfimeaConfirmationActions;

